import * as React from 'react';

interface BounceLoaderProps {
  loading: boolean;
  id?: string;
  texte?: string;
}

interface BounceLoaderState {
  id: string;
  texte: string;
}

export class BounceLoader extends  React.Component<BounceLoaderProps, BounceLoaderState> {
  constructor(props:BounceLoaderProps) {
    super(props);
    this.state = {
      id: this.props.id || 'chargementEnCours',
      texte: this.props.texte || 'Chargement',
    }
  }

  render() {
    return (
      <div id={this.state.id}
           className={`text-right w-100 align-items-center align-self-center justify-content-center my-3 ${this.props.loading ? 'display-flex' : 'display-none'}  loaderBatAuto`}>
        <div className="spinner mr-2">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
        <div className="bold">{this.state.texte}</div>
      </div>
    );
  }
}
